import React from "react";
import { Navigate } from "react-router-dom";
import {
  getSessionProfile,
  isSessionAuthenticated,
} from "./utility/services/session";

/**
 * @param {React.ReactNode} children
 * @param {string[]} [roles] allowed profiles, e.g. ["Admin","Staff"]. Omit = any authenticated.
 */
const PrivateRoute = ({ children, roles }) => {
  if (!isSessionAuthenticated()) {
    return <Navigate to="/user_login" replace />;
  }

  const profile = getSessionProfile();
  if (Array.isArray(roles) && roles.length > 0) {
    if (!profile || !roles.includes(profile)) {
      return <Navigate to="/account" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
